export default __webpack_public_path__ + "static/media/home-image.2d7bced8.png";